import { Button, Col, Form, Input, Row, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import { FaFileAlt } from "react-icons/fa";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { hasRole } from "../../../global/hooks/getUserRole";

export const DeviceProductionFilter = ({
  formFilter,
  handleFormChange,
  filter,
  setFilter,
  handleFilterChange,
  handleFilter,
  handleReset,
  hardwareOptions,
  licenseOptions,
  selectedRowKeys,
  setShowModal,
  setIsModalOpen,
  reportForm,
}) => {
  const navigate = useNavigate();
  return (
    <Form className="" form={formFilter} onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="No"
              value={filter.ProductionNo}
              onChange={(e) => {
                const { value } = e.target;
                // Allow only positive integers or empty string
                if (/^[1-9]\d*$/.test(value) || value === "") {
                  handleFilterChange(e);
                }
              }}
              name="ProductionNo"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="Name"
              value={filter.ProductionName}
              onChange={handleFilterChange}
              name="ProductionName"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="ProductionTime"
              placeholder="Production Time"
              format="YYYY-MM-DD HH:mm"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              placeholder="Hardware"
              allowClear
              style={{ width: "100%" }}
              value={filter.HardwareNo ? Number(filter.HardwareNo) : null}
              onChange={(value) =>
                setFilter({ ...filter, HardwareNo: value ?? "" })
              }
              options={hardwareOptions}
              showSearch
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              placeholder="License"
              allowClear
              style={{ width: "100%" }}
              value={filter.LicenseNo ? Number(filter.LicenseNo) : null}
              onChange={(value) =>
                setFilter({ ...filter, LicenseNo: value ?? "" })
              }
              options={licenseOptions}
              showSearch
            />
          </Col>
        </Row>
      </div>

      <div className="w-full overflow-x-auto">
        <div className="flex justify-between my-4 flex-nowrap min-w-[610px]">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              className="reset-button"
              onClick={() => {
                formFilter.resetFields();
                handleReset();
              }}
            >
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            <Button
              type="primary"
              className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
              onClick={() => navigate("/device-production/add")}
            >
              <PlusOutlined />
              Add
            </Button>
            <Button
              type="primary"
              disabled={selectedRowKeys?.length === 0}
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={() => setShowModal(true)}
            >
              <DeleteOutlined />
              Delete
            </Button>
          </div>
          {hasRole(1, 2, 3) && (
            <div>
              <Button
                type="primary"
                className="w-[162px] h-[30px]"
                onClick={() => {
                  setIsModalOpen(true);
                  reportForm.setFieldValue("ReportFile", 1);
                }}
                disabled={selectedRowKeys.length === 0}
              >
                <FaFileAlt className="!text-[14px] font-medium" />
                Production Report
              </Button>
            </div>
          )}
        </div>
      </div>
    </Form>
  );
};
